import { render, staticRenderFns } from "./appcenter.vue?vue&type=template&id=23bf622c&scoped=true"
import script from "./appcenter.vue?vue&type=script&lang=js"
export * from "./appcenter.vue?vue&type=script&lang=js"
import style0 from "./appcenter.vue?vue&type=style&index=0&id=23bf622c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bf622c",
  null
  
)

export default component.exports